<h5>{{l("Messages")}}</h5>
                
<div #msgContainer class="msg mb-2">
    <div *ngIf="messages && messages.length == 0" style="height: 100%" class="d-flex flex-column justify-content-center">
        <p class="text-center">{{l("Support_NoMessages")}}</p>
    </div>

    @for(msg of messages; track msg.id) {
        <div class="d-flex" [class.msg-mine]="isMine(msg)" [class.msg-other]="!isMine(msg)">
            <div class="msg-content">
                <h6>{{msg.senderDisplayName}}</h6>
                <div class="whitespace">{{msg.text}}</div>
                <div class="text-end text-muted">{{datePipe.transform(msg.creationTime.toJSDate(), "dd.MM.YYYY HH:mm")}}</div>
            </div>
        </div>
    }
</div>

<div class="d-flex gap-2 align-items-end">
    <app-mazars-input-textarea #msgWrite uid="support-messages-input" class="flex-fill" (submit)="writeMessage()"></app-mazars-input-textarea>
    <app-mazars-button #msgSend class="msg-send" iconClass="pi pi-send" [label]="l('Send')" (onClick)="writeMessage()" [disabled]="!(messageInput?.value?.length > 0)"></app-mazars-button>
</div>